import { render, staticRenderFns } from "./CollectionGeneralForm.vue?vue&type=template&id=0e532f4e&scoped=true&"
import script from "./CollectionGeneralForm.vue?vue&type=script&lang=js&"
export * from "./CollectionGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGeneralForm.vue?vue&type=style&index=0&id=0e532f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e532f4e",
  null
  
)

export default component.exports